
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fr/en/accessibility",
      function () {
        return require("private-next-pages/fr/en/accessibility.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fr/en/accessibility"])
      });
    }
  